import React from 'react';
import { Address } from '../../../models';
import { Alert } from '../../shared';
import AddressCard from './AddressCard';

interface UserAddressesProps {
  addresses: Address[];
}

function UserAddresses({ addresses }: UserAddressesProps) {
  return (
    <div className="w-full flex">
      {addresses.length > 0 ? (
        addresses.map((address) => <AddressCard address={address} />)
      ) : (
        <Alert
          title="No posee direcciones"
          text="Este beneficiario no ha registrado aun ninguna dirección"
          show
        />
      )}
    </div>
  );
}

export default UserAddresses;
